import React, { useState, useEffect } from "react";
import Sidebar from "../layouts/sidebar";
// import Navbar from "../layouts/navbar"; // Navbar is optional (currently disabled)
import { Outlet } from "react-router-dom";

export default function Main() {
  // State to handle sidebar and responsiveness
  const [isMobileOpen, setIsMobileOpen] = useState(false); // Mobile sidebar toggle
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Desktop collapse state
  const [isMobile, setIsMobile] = useState(false); // Tracks if current view is mobile/tablet

  // Run on mount + on resize → checks if the screen is mobile or tablet
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768; // Mobile breakpoint
      setIsMobile(mobile);
      const tablet = window.innerWidth < 1024; // Tablet breakpoint
      setIsMobile(tablet);
      if (mobile) {
        setSidebarCollapsed(false);
        setIsMobileOpen(false);
      }
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Calculate margin for the main container depending on sidebar state
  const getMainMargin = () => (isMobile ? "ml-0" : "ml-24");

  // Add top padding only when on mobile and sidebar button is visible
  const getMainPadding = () => (isMobile ? "pt-16 p-4" : "p-4");


  return (
    <div className="flex min-h-screen">
      {/* Fixed Sidebar (collapsible + mobile toggle) */}
      <Sidebar
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isCollapsed={sidebarCollapsed}
        setIsCollapsed={setSidebarCollapsed}
      />

      {/* Main content wrapper → adjusts margin depending on sidebar */}
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${getMainMargin()}`}>
        {/* Navbar placeholder (sticky, with blur) — uncomment when needed */}
        {/* <div className="sticky top-0 z-10 backdrop-blur-lg bg-white/20 px-3">
          <Navbar setIsMobileOpen={setIsMobileOpen} />
        </div> */}

        {/* Scrollable main content */}
        <main className={`flex-1 bg-backgroundColor overflow-y-auto ${getMainPadding()}`}>
          {/* Outlet renders the matched route’s page */}
          <Outlet />
        </main>
      </div>
    </div>
  );
}